import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SideMenuLink } from 'components/side-menu/side-menu.component';
import { ROLE_CODES } from 'constants/role.constants';
import { OrgUserProfile } from 'interfaces/profile.interface';
import { PersonalInfoCommunicationService } from 'features/personal-info/personal-info.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ProfileDetails } from 'features/personal-info/personal-info.component';

@UntilDestroy()
@Component({
  selector: 'cm-profile-page',
  templateUrl: './profile-page.component.html',
  styleUrls: ['./profile-page.component.scss'],
})
export class ProfilePageComponent implements OnInit, OnDestroy {
  profile: OrgUserProfile;
  ROLE_CODES = ROLE_CODES;

  links: SideMenuLink[] = [
    { url: 'profile-details', name: 'Personal Information', icon: 'fa-user' },
    { url: 'custom-fields', name: 'Profile Fields', icon: 'fa-id-card' },
    // 'groups-permissions' ??
    { url: 'email-notifications', name: 'Email Notifications Settings', icon: 'fa-bell' },
  ];

  constructor(
    private route: ActivatedRoute,
    private personalInfoCommunicationService: PersonalInfoCommunicationService,
  ) {}

  ngOnInit() {
    this.profile = this.route.snapshot.data.profile;
    this.personalInfoCommunicationService.updatedProfile$
      .pipe(untilDestroyed(this))
      .subscribe((newProfile: ProfileDetails) => {
        this.profile = newProfile as OrgUserProfile;
      });
  }

  ngOnDestroy() {}
}
